
export const InsuranceParamsType = {
    ObsoleteParams: 0,
    Basic: 1,
    AddOn: 2,
    Poleas: 3,
    Poleas2: 4,
}
export type InsuranceParamsType = typeof InsuranceParamsType[keyof typeof InsuranceParamsType]

type PossibleTypes = InsuranceParamsType | undefined

export const InsuranceParamsTypes: [PossibleTypes, string, string, string, string][] = [
    [InsuranceParamsType.ObsoleteParams, 'Standardní pojištění', "SP", "primary.50", "primary.500"],
    [InsuranceParamsType.Basic, 'Standardní pojištění', "SP", "primary.50", "primary.500"],
    [InsuranceParamsType.AddOn, 'Doplňkové pojištění', "DP", "blue.50", "blue.400"],
    [InsuranceParamsType.Poleas, 'Poleasing 1', "P1", "orange.50", "orange.500"],
    [InsuranceParamsType.Poleas2, 'Poleasing 2', "P2", "orange.50", "orange.500"],
]

export const getInsuranceParamsTypeName = (type: PossibleTypes) => {
    return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[1] : undefined
}

export const getInsuranceParamsTypeShortName = (type: PossibleTypes) => {
    return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[2] : undefined
}

export const getInsuranceParamsTypeColor = (type: PossibleTypes) => {
    return type !== undefined ? [InsuranceParamsTypes.find(([key]) => key === type)?.[3], InsuranceParamsTypes.find(([key]) => key === type)?.[4]] : undefined
}